export const removeStoreeeOverlay = () => {
  const overlay = document.querySelector('.storeee_overlay');
  if (overlay) overlay.remove();
  
  const overlayStyle = document.querySelector('style[data-storeee-overlay]');
  if (overlayStyle) overlayStyle.remove();
};